import { render, staticRenderFns } from "./TheSourceTag.vue?vue&type=template&id=b1c2f1e2&scoped=true&"
import script from "./TheSourceTag.vue?vue&type=script&lang=js&"
export * from "./TheSourceTag.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceTag.vue?vue&type=style&index=0&id=b1c2f1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c2f1e2",
  null
  
)

export default component.exports